export default __webpack_public_path__ + "static/7df2434b78c92b48142226a4ade91e46.jpg";